import { Card, CardContent, TextField } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import { CardSpacer } from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import { Container } from "@saleor/components/Container";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import Hr from "@saleor/components/Hr";
import Metadata from "@saleor/components/Metadata/Metadata";
import { MetadataFormData } from "@saleor/components/Metadata/types";
import PageHeader from "@saleor/components/PageHeader";
// import RecommendProductSection, {
//   RecommendProductTab
// } from "@saleor/components/RecommendProductSection";
import RecommendProductSection from "@saleor/components/RecommendProductSection";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import SeoForm from "@saleor/components/SeoForm";
import SingleSelectField from "@saleor/components/SingleSelectField";
import VisibilityCard from "@saleor/components/VisibilityCard";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import useDateLocalize from "@saleor/hooks/useDateLocalize";
import { sectionNames } from "@saleor/intl";
import {
  CollectionUsedForEnum,
  RecommendationTargetTypeEnum
} from "@saleor/types/globalTypes";
import { mapMetadataItemToInput } from "@saleor/utils/maps";
import useMetadataChangeTrigger from "@saleor/utils/metadata/useMetadataChangeTrigger";
import { RawDraftContentState } from "draft-js";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { ListActions, ReorderAction, TabListActions } from "../../../types";
// import { ListActions, PageListProps, ReorderAction, TabListActions } from "../../../types";
import { CollectionDetails_collection } from "../../types/CollectionDetails";
import CollectionDetails from "../CollectionDetails/CollectionDetails";
import { CollectionImage } from "../CollectionImage/CollectionImage";
import CollectionPopupMessage from "../CollectionPopupMessage";
import CollectionProducts from "../CollectionProducts/CollectionProducts";
import CollectionPrompt from "../CollectionPrompt";

export interface CollectionDetailsPageFormData extends MetadataFormData {
  backgroundImageAlt: string;
  description: RawDraftContentState;
  name: string;
  url: string;
  slug: string;
  publicationDate: string;
  seoDescription: string;
  seoTitle: string;
  seoKeyword: string;
  isFeatured: boolean;
  isPublished: boolean;
  displayOrder: number;
  usedFor: CollectionUsedForEnum;
  promptText: string;
  promptBackgroundColor: string;
  promptTextColor: string;
  promptArrowColor: string;
  promptLink: string;
  showPrompt: boolean;
  isBuytogether: boolean;
  enablePopupMessage: boolean;
  popupMessage: string;
}

export interface CollectionDetailsPageProps  // extends PageListProps,
  extends ListActions,
    TabListActions<
      "recommendToolbar" | "alsolikeToolbar" | "buytogetherToolbar"
    > {
  // changeTab: (index: RecommendProductTab) => void;
  // currentTab: RecommendProductTab;
  collection: CollectionDetails_collection;
  errors: ProductErrorFragment[];
  isFeatured: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onCollectionRemove: () => void;
  onImageDelete: () => void;
  onImageUpload: (file: File) => void;
  onProductUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onSubmit: (data: CollectionDetailsPageFormData) => void;
  onRecommendAssign: () => void;
  onAlsolikeAssign: () => void;
  onBuytogetherAssign: () => void;
  onRecommendUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onAlsolikeUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onBuytogetherUnAssign: (id: string, event: React.MouseEvent<any>) => void;
  onProductReorder: ReorderAction;
  onAdd: () => void;
  onCopyIds: () => void;
  disabled: boolean;
  onRowClick: (id: string) => () => void;
  onProductSelectReorder?: (productId: string, sortOrder: number) => void;
  isBuytogether: boolean;
}

const CollectionDetailsPage: React.FC<CollectionDetailsPageProps> = ({
  // changeTab,
  // currentTab,
  collection,
  disabled,
  errors,
  isFeatured,
  saveButtonBarState,
  onBack,
  onCollectionRemove,
  onImageDelete,
  onImageUpload,
  onSubmit,
  onRecommendAssign,
  onAlsolikeAssign,
  onBuytogetherAssign,
  onRecommendUnassign,
  onAlsolikeUnassign,
  onBuytogetherUnAssign,
  recommendToolbar,
  alsolikeToolbar,
  buytogetherToolbar,
  onProductReorder,
  onRowClick,
  onProductSelectReorder,
  isBuytogether,
  ...collectionProductsProps
}: CollectionDetailsPageProps) => {
  const intl = useIntl();
  const UsedForChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "General",
        description: "collection used for choice"
      }),
      value: CollectionUsedForEnum.GENERAL
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Search Page",
        description: "collection used for choice"
      }),
      value: CollectionUsedForEnum.SEARCH_PAGE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Product Page",
        description: "collection used for choice"
      }),
      value: CollectionUsedForEnum.PRODUCT_PAGE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Empty Shopping Bag",
        description: "collection used for choice"
      }),
      value: CollectionUsedForEnum.EMPTY_SHOPPING_BAG
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Component Page",
        description: "collection used for choice"
      }),
      value: CollectionUsedForEnum.COMPONENT_PAGE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Product Popup Message",
        description: "product popup message used for choice"
      }),
      value: CollectionUsedForEnum.PRODUCT_POPUP_MESSAGE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Product Recommendation",
        description: "Product Recommendation message used for choice"
      }),
      value: CollectionUsedForEnum.PRODUCT_RECOMMENDATION
    }
  ];
  const localizeDate = useDateLocalize();
  const {
    isMetadataModified,
    isPrivateMetadataModified,
    makeChangeHandler: makeMetadataChangeHandler
  } = useMetadataChangeTrigger();

  const handleSubmit = (data: CollectionDetailsPageFormData) => {
    const metadata = isMetadataModified ? data.metadata : undefined;
    const privateMetadata = isPrivateMetadataModified
      ? data.privateMetadata
      : undefined;

    return onSubmit({
      ...data,
      isPublished: data.isPublished || !!data.publicationDate,
      metadata,
      privateMetadata
    });
  };

  return (
    <Form
      initial={{
        backgroundImageAlt: maybe(() => collection.backgroundImage.alt, ""),
        description: maybe(() => JSON.parse(collection.descriptionJson)),
        isFeatured,
        isPublished: maybe(() => collection.isPublished, false),
        metadata: collection?.metadata?.map(mapMetadataItemToInput),
        name: maybe(() => collection.name, ""),
        url: maybe(() => collection.url, ""),
        privateMetadata: collection?.privateMetadata?.map(
          mapMetadataItemToInput
        ),
        publicationDate: maybe(() => collection.publicationDate, ""),
        seoDescription: maybe(() => collection.seoDescription, ""),
        seoTitle: maybe(() => collection.seoTitle, ""),
        seoKeyword: maybe(() => collection.seoKeyword, ""),
        slug: collection?.slug || "",
        usedFor: maybe(() => collection.usedFor, CollectionUsedForEnum.GENERAL),
        displayOrder: maybe(() => collection.displayOrder, 999),
        promptText: maybe(() => collection.promptText, ""),
        promptLink: maybe(() => collection.promptLink, ""),
        promptBackgroundColor: maybe(
          () => collection.promptBackgroundColor,
          ""
        ),
        promptTextColor: maybe(() => collection.promptTextColor, ""),
        promptArrowColor: maybe(() => collection.promptArrowColor, ""),
        showPrompt: maybe(() => !!collection.showPrompt),
        isBuytogether,
        enablePopupMessage: maybe(() => collection.enablePopupMessage),
        popupMessage: maybe(() => collection.popupMessage, "")
      }}
      onSubmit={handleSubmit}
      confirmLeave
    >
      {({ change, data, hasChanged, submit }) => {
        const changeMetadata = makeMetadataChangeHandler(change);

        return (
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.recommendationgroups)}
            </AppHeader>
            <PageHeader title={maybe(() => collection.name)} />
            <Grid>
              <div>
                <CollectionDetails
                  collection={collection}
                  data={data}
                  disabled={disabled}
                  errors={errors}
                  onChange={change}
                />
                <CardSpacer />
                <CollectionProducts
                  onProductReorder={onProductReorder}
                  onProductSelectReorder={onProductSelectReorder}
                  disabled={disabled}
                  collection={collection}
                  onRowClick={onRowClick}
                  {...collectionProductsProps}
                />
                <CardSpacer />
                <RecommendProductSection
                  disabled={disabled}
                  // changeTab={changeTab}
                  // currentTab={currentTab}
                  isBuytogether={isBuytogether}
                  target={collection}
                  targetType={RecommendationTargetTypeEnum.COLLECTION}
                  onRecommendAssign={onRecommendAssign}
                  onAlsolikeAssign={onAlsolikeAssign}
                  onBuytogetherAssign={onBuytogetherAssign}
                  onRecommendUnassign={onRecommendUnassign}
                  onAlsolikeUnassign={onAlsolikeUnassign}
                  onBuytogetherUnAssign={onBuytogetherUnAssign}
                  recommendToolbar={recommendToolbar}
                  alsolikeToolbar={alsolikeToolbar}
                  buytogetherToolbar={buytogetherToolbar}
                  {...collectionProductsProps}
                />
                <CardSpacer />
                <CollectionImage
                  data={data}
                  image={maybe(() => collection.backgroundImage)}
                  onImageDelete={onImageDelete}
                  onImageUpload={onImageUpload}
                  onChange={change}
                />
                <CardSpacer />
                <Metadata data={data} onChange={changeMetadata} />
                <CardSpacer />
                <SeoForm
                  description={data.seoDescription}
                  disabled={disabled}
                  descriptionPlaceholder=""
                  helperText={intl.formatMessage({
                    defaultMessage:
                      "Add search engine title and description to make this recommendation group easier to find"
                  })}
                  errors={errors}
                  slug={data.slug}
                  slugPlaceholder={data.name}
                  title={data.seoTitle}
                  keyword={data.seoKeyword}
                  titlePlaceholder={maybe(() => collection.name)}
                  keywordPlaceholder={maybe(() => collection.name)}
                  onChange={change}
                />
              </div>
              <div>
                <div>
                  <VisibilityCard
                    data={data}
                    errors={errors}
                    messages={{
                      hiddenLabel: intl.formatMessage({
                        defaultMessage: "Hidden",
                        description: "recommendation group label"
                      }),
                      hiddenSecondLabel: intl.formatMessage(
                        {
                          defaultMessage: "will be visible from {date}",
                          description: "recommendation group"
                        },
                        {
                          date: localizeDate(data.publicationDate, "L")
                        }
                      ),
                      visibleLabel: intl.formatMessage({
                        defaultMessage: "Visible",
                        description: "recommendation group label"
                      })
                    }}
                    onChange={change}
                  >
                    <FormSpacer />
                    <Hr />
                    <ControlledCheckbox
                      name={"isFeatured" as keyof CollectionDetailsPageFormData}
                      label={intl.formatMessage({
                        defaultMessage: "Feature on Homepage",
                        description: "switch button"
                      })}
                      checked={data.isFeatured}
                      onChange={change}
                      disabled={disabled}
                    />
                  </VisibilityCard>
                  <CardSpacer />
                  <Card>
                    <CardTitle
                      title={intl.formatMessage({
                        defaultMessage: "About This Group",
                        description: "section header"
                      })}
                    />
                    <CardContent>
                      <SingleSelectField
                        disabled={disabled}
                        choices={UsedForChoices}
                        label={intl.formatMessage({
                          defaultMessage: "Used For",
                          description: "Collection used for choice."
                        })}
                        name={"usedFor" as keyof CollectionDetailsPageFormData}
                        onChange={change}
                        value={data.usedFor}
                      />
                      <CardSpacer />
                      <TextField
                        label={intl.formatMessage({
                          defaultMessage: "Display Order",
                          description: "Display Order"
                        })}
                        name={
                          "displayOrder" as keyof CollectionDetailsPageFormData
                        }
                        disabled={disabled}
                        value={data.displayOrder}
                        onChange={change}
                        fullWidth
                      />
                    </CardContent>
                  </Card>
                  <CardSpacer />
                  <CollectionPrompt
                    data={data}
                    disabled={disabled}
                    errors={errors}
                    onChange={change}
                  />
                  <CardSpacer />
                  <CollectionPopupMessage
                    data={data}
                    disabled={disabled}
                    errors={errors}
                    onChange={change}
                  />
                </div>
              </div>
            </Grid>
            <SaveButtonBar
              state={saveButtonBarState}
              disabled={disabled || !hasChanged}
              onCancel={onBack}
              onDelete={onCollectionRemove}
              onSave={submit}
            />
          </Container>
        );
      }}
    </Form>
  );
};
CollectionDetailsPage.displayName = "CollectionDetailsPage";
export default CollectionDetailsPage;
